import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps } from "vue"

import { computed } from 'vue'

import HighlightedText from '@/components/neue/wizard/HighlightedText'
import SelectionCard from '@/components/neue/wizard/SelectionCard.vue'
import SelectionGroup from '@/components/neue/wizard/SelectionGroup.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import {
  INCLUDE_STEPS,
  includeOptions,
  removalWarnings,
  sectionCopy,
  stepForKey
} from '@/config/membershipTierWizardSteps'


export default {
  __name: 'StepIncludes',
  setup(__props) {

const ICONS = { repeat: 'repeat', mealPlan: 'utensils', memberPrices: 'tag' }

const wizard = injectWizard()
const options = computed(() => includeOptions(wizard.data))
const warnings = computed(() => removalWarnings(wizard.data, wizard.meta?.value ?? {}))

const addsStep = key => (wizard.editing ? '' : `Adds a ${stepForKey(INCLUDE_STEPS[key]).label} step`)

const toggle = key => {
  wizard.data.includes[key] = !wizard.data.includes[key]
}

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(WizardSection, _mergeProps(_unref(sectionCopy)('includes', _unref(wizard).data), { plain: "" }), {
    default: _withCtx(() => [
      _createVNode(SelectionGroup, {
        label: _unref(sectionCopy)('includes', _unref(wizard).data).title,
        mode: "check"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
            return (_openBlock(), _createBlock(SelectionCard, {
              key: option.key,
              mode: "check",
              icon: ICONS[option.key],
              title: option.title,
              subtitle: option.subtitle,
              chip: _unref(wizard).data.includes[option.key] ? addsStep(option.key) : '',
              selected: _unref(wizard).data.includes[option.key],
              onSelect: $event => (toggle(option.key))
            }, null, 8, ["icon", "title", "subtitle", "chip", "selected", "onSelect"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["label"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(warnings.value, (warning) => {
        return (_openBlock(), _createElementBlock("p", {
          key: warning,
          class: "rounded-lg bg-amber-50 px-4 py-3 text-sm text-amber-800"
        }, [
          _createVNode(_unref(HighlightedText), { text: warning }, null, 8, ["text"])
        ]))
      }), 128))
    ]),
    _: 1
  }, 16))
}
}

}